import React, { useState } from "react";
import "../styles/Navbar.css";
import logo from "../assets/yoga-bg.jpg.png";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleNavClick = () => setMenuOpen(false);

  return (
    <>
      <header className="navbar">
        <div className="navbar-container">
          <a href="/" className="logo">
            <img src={logo} alt="Vedyo Logo" />
          </a>

          <div className="company-name">
  VEDYO<sup className="tm-symbol">™</sup>
</div>


          <nav className={`nav-links ${menuOpen ? "mobile-visible" : ""}`}>
            <a onClick={handleNavClick} href="#about">About</a>
            <a onClick={handleNavClick} href="#classes">Classes</a>
            <a onClick={handleNavClick} href="#trainers">Teacher</a>
            <a onClick={handleNavClick} href="#inquiry">Inquiry</a>
          </nav>

          <div
            className={`burger ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </header>

      {menuOpen && <div className="overlay" onClick={handleNavClick}></div>}
    </>
  );
}

export default Navbar;
